/** @format */
import { css } from 'styled-components';

const baseStyles = () => {
    /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    return css`
        cursor: pointer;
        padding: 0.4rem;
        margin: -0.4rem;
        border-radius: 1000px;
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
